import React from "react";
import { useNavigate } from "react-router-dom";
import MostPopularHeader from "./MostPopularHeader";

export default function PricingCard({ plan, isPopular, onSubscribe }) {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (plan.button === "Get Started") {
      navigate("/");
    } else {
      onSubscribe();
    }
  };

  return (
    <div
      className={`relative bg-white rounded-xl shadow-xl border border-gray-200 flex flex-col items-center px-4 py-8 transition-transform duration-200 group hover:-translate-y-1 max-w-sm w-full ${
        isPopular ? "z-0" : ""
      }`}
    >
      {isPopular && <MostPopularHeader />}
      <h3 className="text-lg font-semibold mb-3">{plan.type}</h3>
      <div className="flex items-end mb-1">
        <span className="text-3xl font-bold text-green-500">{plan.price}</span>
        <span className="text-xs ml-2 text-green-500">{plan.period}</span>
      </div>
      {plan.details && (
        <div className="text-xs text-orange-500 mb-2">{plan.details}</div>
      )}
      <button
        className={`w-full mt-3 py-2 text-sm rounded-md font-medium transition-all duration-150 shadow-sm ${plan.buttonStyle}`}
        style={{ minHeight: "40px" }}
        onClick={handleButtonClick}
      >
        {plan.button}
      </button>
      <ul className="list-none mt-6 space-y-2 w-full text-gray-700 text-left text-[0.93rem] font-medium">
        {plan.features.map((feat, idx) => (
          <li key={idx} className="flex items-center gap-2">
            <span className="text-base text-[#17b970] font-extrabold">✓</span>
            <span>{feat}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
